import Swal from 'sweetalert2';
import { apiV2 } from '../actions';
import { handleError } from '../utils/commons';

export const findByIdOrEmail = async (searchText) => {
    try {
        const response = await apiV2.get(`/users/find-by-id-or-email`, {
            params: { search: searchText }
        });
        return response.data;
    } catch (error) {
        handleError(error);
        return null;
    }
};

export const sendPasswordResetLink = (email, setLoading) => {
    setLoading(true);
    apiV2.post(`/customer-support/reset-password-link`, { email })
        .then((response) => {
            const { email: userEmail, date, link } = response.data;
            Swal.fire({
                icon: "success",
                title: "Password Link Generated!",
                html: `Email : ${userEmail} <br> Link : ${link} <br> Expires On : ${date}`,
                heightAuto: true,
            });
        })
        .catch((error) => {
            handleError(error);
        })
        .finally(() => {
            setLoading(false);
        });
}

export const deleteUserByEmail = (email, setLoading) => {
    setLoading(true);
    return apiV2.delete(`/user/${encodeURIComponent(email)}`)
        .then(() => {
            Swal.fire({
                icon: "success",
                title: "User Deleted",
                heightAuto: true,
            });
            return true;
        })
        .catch((error) => {
            handleError(error);
            return false;
        })
        .finally(() => {
            setLoading(false);
        });
}

export const processStripeSubscription = (subId, setLoading) => {
    setLoading(true);
    return apiV2.put(`/user/subscription/stripe`, { sub_id: subId })
        .then((response) => {
            const {
                user_email,
                user_is_premium,
                user_subscription_source,
                expiration_date,
            } = response.data;
            Swal.fire({
                icon: "success",
                title: "User Updated",
                html: `Email : ${user_email} <br> Premium : ${user_is_premium} <br> Source : ${user_subscription_source}  <br> Expires On : ${expiration_date}`,
                heightAuto: true,
            });
            return response.data;
        })
        .catch((error) => {
            handleError(error);
            throw error;
        })
        .finally(() => {
            setLoading(false);
        });
}

export const grantPremiumAccess = async (userId, durationKey, reason) => {
    try {
        const payload = {
            user_id: userId,
            duration: durationKey
        };
        if (reason) payload.reason = reason;

        const response = await apiV2.post('/users/grant-premium', payload);
        Swal.fire({ icon: 'success', title: 'Premium Granted', text: `User ${userId} now has premium for ${durationKey}` });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const bulkGrantPremium = async (usersArray) => {
    try {
        const response = await apiV2.post('/users/grant-premium/bulk', { users: usersArray });
        return response.data;
    } catch (error) {
        handleError(error);
        throw error;
    }
};

export const validateBulkPremiumUsers = async (usersArray) => {
    try {
        const response = await apiV2.post('/users/grant-premium/bulk/validation', { users: usersArray });
        return response.data;
    } catch (error) {
        handleError(error);
        throw error;
    }
};

export const fetchPremiumGrantHistory = async ({ limit = 100, offset = 0, grantType }) => {
    try {
        const page = limit > 0 ? Math.floor(offset / limit) + 1 : 1;
        const response = await apiV2.get('/audit-logs/filtered', {
            params: { grant_type: grantType, per_page: limit, page }
        });
        // Wrap in { data } to match modal's response.data.logs access pattern
        return { data: response.data };
    } catch (error) {
        throw error?.response?.data || error;
    }
};
